import { render, staticRenderFns } from "./LinkTicketCombo.vue?vue&type=template&id=2f4b4302&scoped=true&"
import script from "./LinkTicketCombo.vue?vue&type=script&lang=js&"
export * from "./LinkTicketCombo.vue?vue&type=script&lang=js&"
import style0 from "./LinkTicketCombo.vue?vue&type=style&index=0&id=2f4b4302&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f4b4302",
  null
  
)

export default component.exports